export const SentimentTypes = [ 'saved', 'skipped' ] as const

export type ISentiment = {
  _id: string
  event: string
  place: string
  group: string

  type: typeof SentimentTypes[number]
  owner: string

  createdAt: Date
}

export interface Sentiment extends ISentiment {}

export class Sentiment implements ISentiment {
  
  constructor(props: ISentiment) {

    Object.assign(this, {
      ...props,
    })
  }
}
